/* eslint max-len:0 */
const Croatian = {
    _language: 'croatian',
    _language_short: 'hr',
    agentWelkomMessage: 'Dobrodošli. Postavite svoje pitanje ovdje.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Nije se moglo povezati. Možete {retry}',
    couldNotConnectInner: 'pokušajte ponovno povezivanje sada',
    couldNotConnectWithRetry: 'Nije se moglo povezati. Nastavit ćemo s pokušajem, ili možete {retry}.',
    couldNotConnectWithRetryInner: 'pokušajte sada',
    headerText: 'Kako vam možemo pomoći?',
    imageClickToReload: 'Kliknite za ponovo učitavanje slike.',
    imageClickToView: 'Kliknite za prikaz {size} slike.',
    imagePreviewNotAvailable: 'Prethodni pregled nije dostupan.',
    inputPlaceholder: 'Upišite ovdje, pritisnite <enter> za slanje.',
    inputPlaceholderBlocked: 'Ispunite obrazac iznad...',
    introAppText: 'Pošaljite svoju poruku u nastavku ili s omiljenog kanala.',
    introductionText: 'Postavite svoje pitanje ovdje.',
    actionPaymentCompleted: 'Plačanje primljeno.',
    actionPaymentError: 'Došlo je do pogreške prilikom obrade plačanja. <br> Pokušajte ponovno ili koristite drugu karticu.',
    actionPostbackError: 'Došlo je do pogreške prilikom obrade vaše akcije. Pokušajte ponovno.',
    clickToRetry: 'Poruka nije dostavljena. Pokušajte ponovno.',
    clickToRetryForm: 'Obrazac nije poslan. Kliknite bilo gdje na obrazac za ponovni pokušaj.',
    connectNotificationText: 'Čekajte odgovor ili odaberite aplikaciju u kojoj želite nastaviti.',
    connectNotificationSingleText: 'Čekajte odgovor ili odaberite aplikaciju u kojoj želite nastaviti.',
    connectNotificationSingleButtonText: 'Uključite <name> obavijesti',
    connectNotificationOthersText: 'drugi',
    emailChangeAddress: 'Promijenite moj e-mail',
    emailDescription: 'Da biste bili obaviješteni putem e-pošte kada dobijete odgovor, unesite svoju e-mail adresu.',
    emailFieldLabel: 'Vaš e-mail',
    emailFieldPlaceholder: 'Vaša e-mail adresa',
    emailFormButton: 'Nastavite',
    fetchHistory: 'Učitaj više',
    fetchingHistory: 'Dohvaćanje povijesti...',
    frontendEmailChannelDescription: 'Pošaljite nam e-mail i mi ćemo vam se javiti što je prije moguće.',
    invalidFileError: 'Podržane su samo slike. Odaberite datoteku s podržanom ekstenzijom (jpg, jpeg, png, gif ili bmp).',
    lineChannelDescription: 'Skenirajte QR kod za razgovor s nama putem LINE-a.',
    locationNotSupported: 'Vaš preglednik ne podržava usluge lokacije ili su one onemogućene. Unesite svoju lokaciju umjesto toga.',
    locationSecurityRestriction: 'Ova web stranica ne može pristupiti vašoj lokaciji. Unesite svoju lokaciju umjesto toga.',
    locationSendingFailed: 'Nije bilo moguće poslati lokaciju',
    locationServicesDenied: 'Ova web stranica ne može pristupiti vašoj lokaciji. Dopustite pristup u postavkama ili unesite svoju lokaciju.',
    messageError: 'Došlo je do pogreške prilikom slanja vaše poruke. Pokušajte ponovno.',
    messageIndicatorTitlePlural: '({count}) Novi poruke',
    messageIndicatorTitleSingular: '({count}) Nova poruka',
    messageRelativeTimeDay: 'prije {value}d',
    messageRelativeTimeHour: 'prije {value}h',
    messageRelativeTimeJustNow: 'Prije trenutka',
    messageRelativeTimeMinute: 'prije {value}m',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Šaljem...',
    messageDelivered: 'Isporučeno',
    messengerChannelDescription: 'Povežite svoj Facebook račun kako biste nastavili putem Facebook Messengera.',
    whatsappChannelDescriptionDesktop: 'Započnite ili nastavite svoj razgovor putem WhatsApp-a? Kliknite na donji link.',
    whatsappChannelDescriptionMobile: 'Započnite ili nastavite svoj razgovor putem WhatsApp-a? Kliknite na donji link.',
    whatsappLinkingError: 'Nešto je pošlo po zlu prilikom povezivanja. Pokušajte ponovno.',
    notificationSettingsChannelsDescription: 'Također nam se možete obratiti s omiljene aplikacije ili usluge.',
    notificationSettingsChannelsTitle: 'Ostale aplikacije',
    notificationSettingsConnected: 'Povezano',
    notificationSettingsConnectedAs: 'Povezano kao {username}',
    prechatCaptureGreetingText: 'Pozdrav 👋\nZa početak, željeli bismo znati nešto više o vama:',
    prechatCaptureNameLabel: 'Vaše ime',
    prechatCaptureNamePlaceholder: 'Unesite svoje ime...',
    prechatCaptureEmailLabel: 'E-mail',
    prechatCaptureEmailPlaceholder: 'ime@tvrtka.com',
    prechatCaptureConfirmationText: 'Hvala na tome! Kako vam možemo pomoći?',
    prechatCaptureMailgunLinkingConfirmation: 'Bit ćete obaviješteni ovdje i putem e-maila na {email} kada odgovorimo.',
    sendButtonText: 'Pošaljite',
    settingsHeaderText: 'Postavke',
    smsBadRequestError: 'Nismo mogli uspostaviti vezu s tim brojem. Pokušajte ponovno ili koristite drugi broj.',
    smsCancel: 'Otkaži',
    smsChangeNumber: 'Promijeni moj broj',
    smsChannelDescription: 'Povežite svoj SMS broj kako biste nastavili putem SMS-a.',
    smsChannelPendingDescription: 'Provjerite svoje poruke na {number} kako biste potvrdili svoj telefonski broj.',
    smsContinue: 'Nastavite',
    smsInvalidNumberError: 'Vaš broj telefona nije valjan. Pokušajte ponovno.',
    smsLinkCancelled: 'Veza s {appUserNumber} je otkazana.',
    smsLinkPending: 'Na čekanju',
    smsPingChannelError: 'Došlo je do pogreške prilikom slanja poruke na vaš broj.',
    smsSendText: 'Pošaljite mi SMS',
    smsStartTexting: 'Počnite slati SMS',
    smsTooManyRequestsError: 'Za taj broj nedavno je zatražena veza. Pokušajte ponovno za {minutes} minuta.',
    smsTooManyRequestsOneMinuteError: 'Za taj broj nedavno je zatražena veza. Pokušajte ponovno za 1 minutu.',
    smsUnhandledError: 'Nešto je pošlo po zlu. Pokušajte ponovno.',
    tapToRetry: 'Poruka nije dostavljena. Pritisnite enter za ponovni pokušaj.',
    tapToRetryForm: 'Obrazac nije poslan. Kliknite bilo gdje na obrazac za ponovni pokušaj.',
    telegramChannelDescription: 'Povežite svoj Telegram račun kako biste nastavili putem Telegrama',
    unsupportedMessageType: 'Nepodržani tip poruke.',
    unsupportedActionType: 'Nepodržani tip akcije.',
    linkError: 'Došlo je do pogreške prilikom pokušaja generiranja linka za ovaj kanal. Pokušajte ponovno.',
    viberChannelDescription: 'Povežite svoj Viber račun kako biste nastavili putem Vibera',
    viberChannelDescriptionMobile: 'Povežite svoj Viber račun kako biste bili obaviješteni kada dobijete odgovor i nastavili razgovor na Viberu. Za početak, instalirajte Viber aplikaciju i pritisnite Poveži.',
    viberQRCodeError: 'Došlo je do pogreške prilikom dohvaćanja vašeg Viber QR koda. Pokušajte ponovno.',
    wechatChannelDescription: 'Povežite svoj WeChat račun kako biste bili obaviješteni kada dobijete odgovor i nastavili razgovor na WeChatu. Za početak, skenirajte ovaj QR kod pomoću WeChat aplikacije.',
    wechatChannelDescriptionMobile: 'Povežite svoj WeChat račun kako biste bili obaviješteni kada dobijete odgovor i nastavili razgovor na WeChatu. Za početak, spremite ovu sliku QR koda i prenesite je <a href="weixin://dl/scan">skenerom QR koda</a>.',
    wechatQRCodeError: 'Došlo je do pogreške prilikom dohvaćanja vašeg WeChat QR koda. Pokušajte ponovno.',
    fileTooLargeError: 'Prekoračen maksimalni limit veličine datoteke ({size})',
    shareLocation: 'Podijelite lokaciju',
    uploadDocument: 'Otpremite dokument',
    uploadInvalidError: 'Nevažeća datoteka',
    fileTypeError: 'Nepodržani tip datoteke',
    formErrorInvalidEmail: 'E-mail je nevažeći',
    formErrorNoLongerThan: 'Ne smije sadržavati više od ({characters}) znakova',
    formErrorNoShorterThan: 'Morate sadržavati najmanje ({characters}) znakova',
    formErrorUnknown: 'Ovo izgleda nije u redu',
    formFieldSelectPlaceholderFallback: 'Odaberite jedno...',
    uploadPhoto: 'Otpremite fotografiju',
    uploadVirusError: 'U vašoj datoteci je otkriven virus i ona je odbijena',
    shoutoutText: 'Započnite razgovor',
    cardClickText: 'Odabrano'
};
export { Croatian };
